import { z } from 'zod';

export const DatiqGeoSuggestionSchema = z.object({
    displayName: z.string(),
    pointId: z.number(),
    latitude: z.number(),
    longitude: z.number(),
    city: z.string().optional(),
    stateProv: z.string().optional(),
    postalCode: z.string().optional(),
    country: z.string().optional(),
})